(() => {
  if (customElements.get('accordion-expandable')) return;

  class AccordionExpandable extends HTMLElement {
    constructor() {
      super();
      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.checkIfToggleNeeded = this.checkIfToggleNeeded.bind(this);
    }

    connectedCallback() {
      this.contentWrapper = this.querySelector('[data-expandable-content]');
      this.toggleButton = this.querySelector('[data-expandable-toggle]');

      if (!this.contentWrapper || !this.toggleButton) return;

      this.toggleButton.addEventListener('click', this.handleToggleClick);
      
      this.setAttribute('data-expanded', 'false');
      
      this.checkIfToggleNeeded();
      
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.checkIfToggleNeeded());
      }
      
      if (document.readyState === 'loading') {
        window.addEventListener('load', this.checkIfToggleNeeded);
      } else {
        setTimeout(() => this.checkIfToggleNeeded(), 100);
      }
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.handleToggleClick);
      window.removeEventListener('load', this.checkIfToggleNeeded);
    }

    checkIfToggleNeeded() {
      requestAnimationFrame(() => {
        const isOverflowing = this.contentWrapper.scrollHeight > this.contentWrapper.clientHeight;
        
        if (isOverflowing) {
          this.toggleButton.hidden = false;
          this.toggleButton.style.display = ''; // Explicitly show
        } else {
          this.toggleButton.hidden = true;
        }
      });
    }

    handleToggleClick(event) {
      event.preventDefault();

      const isExpanded = this.getAttribute('data-expanded') === 'true';

      if (isExpanded) {
        this.setAttribute('data-expanded', 'false');
      } else {
        this.setAttribute('data-expanded', 'true');
      }
    }
  }

  customElements.define('accordion-expandable', AccordionExpandable);
})();
